import React, { useEffect } from 'react';
import moment from 'moment';

import MissionControlBoardView from './MissionControlBoard.view';

type Props = Record<never, never>;

const MissionControlBoard: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const [currentTimeState, setCurrentTimeState] = React.useState<moment.Moment>(moment());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTimeState(() => moment());
    }, 1_000);

    return () => {
      clearInterval(interval);
    };
  }, [setCurrentTimeState]);

  return <MissionControlBoardView currentTime={currentTimeState}>{props.children}</MissionControlBoardView>;
};

MissionControlBoard.displayName = 'MissionControlBoard';
MissionControlBoard.defaultProps = {};

export default MissionControlBoard;
